import React from 'react';
import { WorkingStyle } from '../../types';
import WorkingStylesCell from '../WorkingStyleCell';
import { cells } from './cells';
import { Tooltip } from 'antd';
import classNames from 'classnames';

// maybe get metadata here
interface WorkingStylesRowProps {
  data: WorkingStyle;
  index: number;
  hasTopLegend?: boolean;
  isEditable?: boolean;
  editRow?: (row: WorkingStyle) => void;
}

const WorkingStylesRow = ({
  data,
  editRow,
  index,
  hasTopLegend = false,
  isEditable = false,
}: WorkingStylesRowProps) => {
  const handleRowEdit = (selection: number) => {
    if (!isEditable) return;
    const newSelection = { ...data, selectedScore: selection };
    editRow?.(newSelection);
  };

  const isFlipped = index % 2 !== 0;
  const inverseTraitLegend = (
    <Tooltip title={data?.inverseTraitDescription}>
      <span>{data?.inverseTraitName}</span>
    </Tooltip>
  );

  const traitLegend = (
    <Tooltip title={data?.traitDescription}>
      <span>{data?.traitName}</span>
    </Tooltip>
  );

  const leftLegend = isFlipped ? traitLegend : inverseTraitLegend;
  const rightLegend = isFlipped ? inverseTraitLegend : traitLegend;

  return (
    <div className="tw-flex tw-gap-8 tw-items-center">
      <div className="tw-text-sm tw-font-medium tw-leading-5 tw-text-right tw-w-[200px]">
        {leftLegend}
      </div>
      <div
        className={classNames('tw-w-full tw-flex', {
          'tw-rotate-180': isFlipped,
        })}
      >
        {cells.map((el, index) => (
          <div key={index} className={'tw-w-full tw-text-center'}>
            {hasTopLegend && el.topLegend}
            <WorkingStylesCell
              isEditable={isEditable}
              style={el.style}
              lowerLimit={el.lowerLimit}
              upperLimit={el.upperLimit}
              groupOneValue={data?.topGroupScore}
              groupTwoValue={data?.remainingGroupScore}
              selectedValue={data?.selectedScore}
              selectNewValue={handleRowEdit}
              isFlipped={isFlipped}
            />
          </div>
        ))}
      </div>
      <div className="tw-text-sm tw-font-medium tw-leading-5 tw-text-left tw-w-[200px]">
        {rightLegend}
      </div>
    </div>
  );
};
export default WorkingStylesRow;
